export default {
  production: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5c9376af2ea50c081bdb6737',
    },
    pusher: {
      key: 'e05c254d5c0c0a0a3efc',
      cluster: 'us3',
    },
  },
  preview: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5c9376af2ea50c081bdb6737',
    },
    pusher: {
      key: 'e05c254d5c0c0a0a3efc',
      cluster: 'us3',
    },
  },
  staging: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5c937c534421b90813e73c30',
    },
    pusher: {
      key: '6a109a41b0e436bb9e5d',
      cluster: 'us3',
    },
  },
  ca_production: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5e3c45734d009c0746a85cd3',
    },
    pusher: {
      key: '066b33db3092f82d58e8',
      cluster: 'us3',
    },
  },
  ca_staging: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5e3c45804d009c0746a85ceb',
    },
    pusher: {
      key: '53f05551f1813bc23aa9',
      cluster: 'us3',
    },
  },
  eu_production: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5e53b910bbbf4307e617d3ed',
    },
    pusher: {
      key: 'f738f0f64cbde95f00b3',
      cluster: 'eu',
    },
  },
  eu_staging: {
    datadog_rum: {
      applicationId: '43a98cf8-4ef5-4d03-b427-f4946608c7a7',
      clientToken: 'pubca5ddb9d3b3b981ffb3e7b0f4b4e2b5a', // gitleaks:allow
    },
    launch_darkly: {
      key: '5e53b918bbbf4307e617d407',
    },
    pusher: {
      key: '0ea47013524782c7fadb',
      cluster: 'eu',
    },
  },
  development: {
    datadog_rum: {
      applicationId: '',
      clientToken: '',
    },
    launch_darkly: {
      key: '5c937c5f4421b90813e73c35',
    },
    pusher: {
      key: '48a84e71215c2614b5ca',
      cluster: 'us3',
    },
  },
  local: {
    datadog_rum: {
      applicationId: '',
      clientToken: '',
    },
    launch_darkly: {
      key: '5c937c5f4421b90813e73c35',
    },
    pusher: {
      key: '48a84e71215c2614b5ca',
      cluster: 'us3',
    },
  },
  test: {
    datadog_rum: {
      applicationId: '',
      clientToken: '',
    },
    launch_darkly: {
      key: '5c9376af2ea50c081bdb6736',
    },
    pusher: {
      key: '6ea5f123f092e6b57a9b',
      cluster: 'us3',
    },
  },
};
